export default __webpack_public_path__ + "static/media/no-reward-img.92d1ce99.png";